import type { FC } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import PeriodContext from 'app/common/PeriodContext';
import Dropdown from 'app/components/Dropdown';

import style from './style.module.scss';

const DropdownPeriod: FC = () => {
  const { period, setPeriod } = useContext(PeriodContext);
  const { t } = useTranslation();

  const options: { label: string; value: StatPeriod }[] = [
    { label: t('all-period-series'), value: 'series' },
    { label: t('all-period-last_3_months'), value: '3-month' }
  ];

  return (
    <Dropdown
      options={options}
      value={period}
      onChange={val => setPeriod(val as StatPeriod)}
      className={style.periodDrowpdown}
    />
  );
};

DropdownPeriod.displayName = 'DropdownPeriod';

export default DropdownPeriod;
